import React from 'react';
import PropTypes from 'prop-types';
import useHandlingList from '@afosto/queries/fulfilment/useHandlingList';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

const HandlingListFormatter = ({ handlingListId }) => {
  const { data: handlingList, isLoading } = useHandlingList(handlingListId, {
    enabled: handlingListId,
  });

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  return handlingList ? (
    <MuiLink variant="subtitle1" component={Link} to={`/handling-lists/${handlingListId}/process`}>
      {handlingList?.number ?? 'Concept'}
    </MuiLink>
  ) : (
    '-'
  );
};

HandlingListFormatter.propTypes = {
  handlingListId: PropTypes.string,
};

HandlingListFormatter.defaultProps = {
  handlingListId: undefined,
};

export default HandlingListFormatter;
